/* eslint-disable */
// export const serverUrl =
// process.env.NODE_ENV === 'production'
//   ? 'https://api.slovozivota.sk'
//   : 'http://localhost:8000'
export const serverUrl = 'https://api.slovozivota.sk'
// export const serverUrl = 'http://localhost:8000'
/* eslint-enable */
